package com.downdogapp.client

fun main() {
  println("client module loaded")
}

actual object Util {

  actual val isSmallPhone: Boolean get() = false
  actual val safeAreaTopMargin: Double get() = 0.0
  actual val safeAreaBottomMargin: Double get() = 0.0
}
